import React from 'react';
import { Box, Button, Grid, Paper, Tab, Tabs } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PageHeader from '../../../../components/page-header';
import { getAmendmentTypeLabel } from '../../../../model/sge/amendment/amendment-enums';
import { useAmendmentDetailController } from './context/amendment-detail-controller';
import { useAmendmentDetailState } from './context/amendment-detail-context';
import { TabPanel } from './components/detail-parts';
import { AmendmentSummary } from './components/amendment-summary';
import { CommitmentsTab } from './components/commitments-tab';
import { AccountReportsTab } from './components/account-reports-tab';
import { AttachmentsTab } from './components/attachments-tab';
import { TransfersTab } from './components/transfers-tab';
import { CommitmentDrawer } from './components/commitment-drawer';
import { LiquidationDrawer } from './components/liquidation-drawer';
import { PaymentDrawer } from './components/payment-drawer';
import { TransferDrawer } from './components/transfer-drawer';
import { AccountReportDrawer } from './components/account-report-drawer';

export function AmendmentDetailComponent() {
    const state = useAmendmentDetailState();
    const ctrl = useAmendmentDetailController();
    const { amendment } = state;
    const parlamentarian = state.parlamentarians.find((p) => p.id === amendment?.parlamentarId);
    const politicalParty = state.politicalParties.find((p) => p.id === amendment?.politicalPartyId);
    const amendmentLabel = amendment?.name || 'Emenda';

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title={amendmentLabel}
                    subtitle={amendment ? `Exercício ${amendment.year} • ${getAmendmentTypeLabel(amendment.type)}` : undefined}
                    breadcrumbs={[{ label: 'Emendas', href: '/emendas' }, { label: amendmentLabel }]}
                    actions={
                        <React.Fragment>
                            <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={ctrl.navigateToList}>Voltar</Button>
                            <Button variant="contained" startIcon={<EditIcon />} onClick={ctrl.navigateToEdit}>Editar</Button>
                        </React.Fragment>
                    }
                />
            </Grid>

            <Grid item xs={12}>
                <AmendmentSummary amendment={amendment} parlamentarian={parlamentarian} politicalParty={politicalParty} />
            </Grid>

            <Grid item xs={12}>
                <Paper elevation={3}>
                    <Tabs value={state.tabIndex} onChange={ctrl.handleTabChange} variant="scrollable" scrollButtons="auto">
                        <Tab icon={<ReceiptLongIcon fontSize="small" />} iconPosition="start" label={`Empenhos (${state.commitments.length})`} />
                        <Tab icon={<FactCheckIcon fontSize="small" />} iconPosition="start" label={`Prestação de Contas (${state.accountReports.length})`} />
                        <Tab icon={<AttachFileIcon fontSize="small" />} iconPosition="start" label={`Anexos (${state.attachments.length})`} />
                        <Tab icon={<SwapHorizIcon fontSize="small" />} iconPosition="start" label={`Transferências (${state.transfers.length})`} />
                    </Tabs>
                    <Box sx={{ p: 2 }}>
                        <TabPanel value={state.tabIndex} index={0}><CommitmentsTab ctrl={ctrl} /></TabPanel>
                        <TabPanel value={state.tabIndex} index={1}><AccountReportsTab ctrl={ctrl} /></TabPanel>
                        <TabPanel value={state.tabIndex} index={2}><AttachmentsTab ctrl={ctrl} /></TabPanel>
                        <TabPanel value={state.tabIndex} index={3}><TransfersTab ctrl={ctrl} /></TabPanel>
                    </Box>
                </Paper>
            </Grid>

            <CommitmentDrawer
                open={state.commitmentDrawer.open}
                initial={state.commitmentDrawer.record}
                suppliers={state.suppliers}
                isSaving={ctrl.isSaving}
                onClose={() => ctrl.closeDrawer('commitmentDrawer')}
                onSave={ctrl.saveCommitment}
            />
            <LiquidationDrawer
                open={state.liquidationDrawer.open}
                initial={state.liquidationDrawer.record}
                commitment={state.selectedCommitment}
                liquidations={state.liquidations}
                isSaving={ctrl.isSaving}
                onClose={() => ctrl.closeDrawer('liquidationDrawer')}
                onSave={ctrl.saveLiquidation}
            />
            <PaymentDrawer
                open={state.paymentDrawer.open}
                initial={state.paymentDrawer.record}
                liquidation={state.paymentDrawer.liquidation}
                payments={state.payments}
                isSaving={ctrl.isSaving}
                onClose={() => ctrl.closeDrawer('paymentDrawer')}
                onSave={ctrl.savePayment}
            />
            <TransferDrawer
                open={state.transferDrawer.open}
                initial={state.transferDrawer.record}
                isSaving={ctrl.isSaving}
                onClose={() => ctrl.closeDrawer('transferDrawer')}
                onSave={ctrl.saveTransfer}
            />
            <AccountReportDrawer
                open={state.accountReportDrawer.open}
                initial={state.accountReportDrawer.record}
                attachments={state.accountReportDrawer.attachments}
                isSaving={ctrl.isSaving}
                onClose={() => ctrl.closeDrawer('accountReportDrawer')}
                onSave={ctrl.saveAccountReport}
                onDownloadAttachment={ctrl.downloadAttachment}
                onDeleteAttachment={ctrl.deleteAccountReportAttachment}
            />
        </React.Fragment>
    );
}
